export default __webpack_public_path__ + "static/media/cnbc.36df2810.jpg";